module.exports = __webpack_public_path__ + "img/quizstarcentersection.7a2974d7.png";